export default __webpack_public_path__ + "static/media/Icon1.1dc25cf4.svg";